// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class DuplicateLayoutReducer extends Reducer
{
	public static reducerName: string = "DuplicateLayout";
	public static call(_layoutId: number) {
		this.getReducer().call(_layoutId);
	}

	public call(_layoutId: number) {
		const serializer = this.client.getSerializer();
		let _layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_layoutIdType, _layoutId);
		this.client.call("DuplicateLayout", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let layoutIdValue = AlgebraicValue.deserialize(layoutIdType, adapter.next())
		let layoutId = layoutIdValue.asNumber();
		return [layoutId];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _layoutId: number) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _layoutId: number) => void)
	{
		this.client.on("reducer:DuplicateLayout", callback);
	}
}


export default DuplicateLayoutReducer
